import { useSupergridMutations } from '@aleph/supergrid';
import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';
import { useMemo } from 'react';
import { CampaignStatus, GroupStatus } from 'wb-spotify/graphql/generated';
import { SpotifySuperGridMutationsConfig } from 'wb-spotify/app/routes/superGrid/mutator/utils';
import { SPOTIFY_SUPERGRID_CONFIG } from 'wb-spotify/app/routes/superGrid/config';

function usePublishButtonVisibility(level?: SpotifyLevel) {
	const {
		mutations: storeMutations,
		getMutationsWithParents,
	} = useSupergridMutations<SpotifySuperGridMutationsConfig>();

	const mutations = useMemo(
		() => getMutationsWithParents(SPOTIFY_SUPERGRID_CONFIG),
		[storeMutations],
	);

	const canPublish = useMemo(() => {
		const campaign = mutations[SpotifyLevel.CAMPAIGN];
		const group = mutations[SpotifyLevel.GROUP];

		if (campaign?.some(c => c?.status === CampaignStatus.Draft)
			|| group?.some(g => g?.status === GroupStatus.Draft)) {
			return false;
		}

		return true;
	}, [mutations]);

	const showPublishButton = useMemo(() => {
		if (level && level !== SpotifyLevel.AD) {
			return true;
		}

		return canPublish;
	}, [level, canPublish]);

	return showPublishButton;
}

export default usePublishButtonVisibility;
